"use client";
import type { ReactElement } from "react";
import { cn } from "@/lib/cn";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

export function RecordingConsentCheckbox({ checked, onChange, className }: Props): ReactElement {
  return (
    <label className={cn("flex cursor-pointer items-start gap-3", className)}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-neutral-300 accent-[#029391]"
      />
      <span className="text-sm text-neutral-700">
        I agree this meeting will be recorded.
      </span>
    </label>
  );
}
